import { useCallback } from 'react';
import Helmet from 'react-helmet';

import { RefreshCwIcon } from 'lucide-react';
import { Button, FormBody } from 'twyne-new.ui';

import HeaderContainerGrid from '@/components/headerContainer/Grid';
import { useAppAlert } from '@Components/AppAlert';

import Form from '../components/ThemeSelectorForm';
import { SettingProvider, ThemeProvider, useSettingStore, useThemeStore } from '../store';

function ThemeSelectorForm() {
  const { useLoad, themes } = useThemeStore()
  const { syncTheme, loading } = useSettingStore()
  const { handleSuccess, handleError } = useAppAlert()

  useLoad()

  const handleSyncTheme = useCallback(async () => {
    try {
      await syncTheme()
      handleSuccess('Success', `Theme synced.`)
    } catch (error) {
      handleError('Error', 'Theme was not synced.')
    }
  }, [syncTheme, handleSuccess, handleError])

  return <>
    <Helmet title="Themes" />
    <HeaderContainerGrid title='Themes'>
      <Button color="accent" size="lg" onClick={handleSyncTheme} disabled={loading}>
        <RefreshCwIcon size={14} className={loading ? 'animate-spin' : ''} /> Sync Theme
      </Button>
    </HeaderContainerGrid>
    <FormBody>
      <Form themes={themes} />
    </FormBody>
  </>
}

export default function ThemeSelectorFormLayout() {
  return <ThemeProvider>
    <SettingProvider>
      <ThemeSelectorForm />
    </SettingProvider>
  </ThemeProvider>;
}
